// Meet The Fabrics slider
import EmblaBase from './embla-carousel-base';
import Autoplay from 'embla-carousel-autoplay';

class FabricSlider extends EmblaBase {
  constructor() {
    super();
    // Options already default to { loop: true } in the base class
  }

  // Override to add autoplay plugin
  createPlugins() {
    return [Autoplay()];
  }
}

customElements.define('fabric-slider', FabricSlider);
